import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Dayjs } from 'dayjs'

export type MaternityInfoWithConcentDate = {
  consentDate: Dayjs;
};

export type MaternityInfoWithoutConcentDate = {
  id?: number
  name: string
  amountReceipt: number
  amountClaim: number
  receiptFile: string
  optionalFileUrl: string
  birthCertificate: string
  otherDocument: string
  relativeTypeId: string
  receiptDate: string
  slipNo?: string
  claimName: string
  receiptNo: string
  remark?: string
};

export type MaternityInf = {
  claimInfo: MaternityInfoWithConcentDate | MaternityInfoWithoutConcentDate
}

export const initState: MaternityInf = {
  claimInfo: {
    name: '',
    amountReceipt: 0,
    amountClaim: 0,
    receiptFile: '',
    optionalFileUrl: '',
    birthCertificate: '',
    otherDocument: '',
    relativeTypeId: '',
    receiptDate: '',
    claimName: '',
    receiptNo: '',
    remark: '',
  },
}

const maternitySlice = createSlice({
  name: 'maternity',
  initialState: initState,
  reducers: {
    setMaternityInfo: (state, { payload }: PayloadAction<MaternityInf['claimInfo']>) => {
      state.claimInfo = payload
    },
    clearMaternityInfo: (state) => {
      state.claimInfo = initState.claimInfo
    },
  },
})

export const maternityReducer = maternitySlice.reducer

export const { setMaternityInfo, clearMaternityInfo } = maternitySlice.actions
